module.exports = __webpack_public_path__ + "static/media/lv.555b843c.svg";